/**
 * `request.reasons` (Strapi multi-enum) may arrive as an array, a JSON string, or a single value.
 */
export function normalizeRequestReasons(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.filter((r): r is string => typeof r === 'string' && r.trim().length > 0);
  }
  if (typeof value === 'string') {
    const t = value.trim();
    if (!t) return [];
    if (t.startsWith('[')) {
      try {
        const parsed = JSON.parse(t) as unknown;
        return Array.isArray(parsed)
          ? parsed.filter((r): r is string => typeof r === 'string' && r.trim().length > 0)
          : [];
      } catch {
        return [t];
      }
    }
    return [t];
  }
  return [];
}

/** Supports `{ id, attributes }`, nested `{ data: { attributes } }`, or flat rows. */
export function getReasonsFromRequestEntity(entity: unknown): string[] {
  if (!entity || typeof entity !== 'object') return [];
  const e = entity as {
    data?: { attributes?: { reasons?: unknown } };
    attributes?: { reasons?: unknown };
    reasons?: unknown;
  };
  const fromData = normalizeRequestReasons(e.data?.attributes?.reasons);
  if (fromData.length) return fromData;
  const fromAttrs = normalizeRequestReasons(e.attributes?.reasons);
  if (fromAttrs.length) return fromAttrs;
  return normalizeRequestReasons(e.reasons);
}
